module.exports = __webpack_public_path__ + "static/media/pouch-pass-logo-white.e2addf86.svg";